require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var escapeElement = require('./escape-element').escapeElement;
/**
 * Represents an XML text value.
 * @api private
 */


function XmlText(value) {
  this.value = value;
}

XmlText.prototype.toString = function () {
  return escapeElement('' + this.value);
};
/**
 * @api private
 */


module.exports = {
  XmlText: XmlText
};